// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class ResourceRestrictionRuleSetRecord extends VerofreshRecord {
}

export default ResourceRestrictionRuleSetRecord
